import React from 'react'
import PropTypes from 'prop-types'
import { useAIRiskReportExportMode } from '../RenderMode/AIRiskReportRenderModeProvider'
import styles from './EmployeeUserCell.module.scss'

export default function EmployeeUserCell({ row, onOpen, displayName = null, secondary = null }) {
  const isExportMode = useAIRiskReportExportMode()
  const employeeName = displayName || row.displayName || row.userPrincipalName
  const isInteractive = Boolean(row.employeeId) && !isExportMode

  return (
    <>
      {isInteractive ? (
        <button type="button" className={styles.nameButton} onClick={() => onOpen(row)}>
          {employeeName}
        </button>
      ) : (
        <div className="text-body fw-bold">{employeeName}</div>
      )}
      {secondary && <div className={styles.cellSub}>{secondary}</div>}
    </>
  )
}

EmployeeUserCell.propTypes = {
  row: PropTypes.shape({
    displayName: PropTypes.string,
    employeeId: PropTypes.number,
    userPrincipalName: PropTypes.string,
  }).isRequired,
  onOpen: PropTypes.func.isRequired,
  displayName: PropTypes.node,
  secondary: PropTypes.node,
}
